import "../css/Partners.css"

const Partners = () => {
    return (
        <div id="partners">
            <h1>Partners tecnológicos</h1>
            <section>
                <p>
                    Nuestro departamento de ingeniería trabaja en equipo con las marcas líderes mundiales en informática, vídeo y equipamientos de congresos como son <strong>Microsoft, Adobe, Oracle, Bosch, Panasonic, HP, Autonomy o Wowza</strong> para conseguir un sistema homogéneo y robusto, que evite duplicidades pero genere redundancias en su uso.
                </p>
                <p>
                    Gracias a estas alianzas somos capaces de integrar con éxito la <strong>última tecnología</strong> de forma equilibrada y rentable para nuestros clientes. Además contamos con acuerdos de investigación con centros universitarios y de investigación como son <strong>Universidad de Vigo, Gradiant</strong> o el <strong>Centro de Supercomputación de Galicia</strong>.
                </p>
            </section>

            {/* FOTOS PARTNERS */}
            <div id="partnersLogoContainer">
                <section className="flex acenter">
                    <a href="https://business.panasonic.es/professional-camera/caso-de%20exito/mutua-universal-renueva-el-equipamiento-de-sus-clinicas-online-con-camaras-ptz-de-panasonic" target="_blank" rel="noopener noreferrer">
                        <img class="partner-logo" alt="logo panasonic" src="/images/partners/Panasonic.webp" />
                    </a>

                    <a href="https://pro.sony/es_ES/products/professional-displays" target="_blank" rel="noopener noreferrer">
                        <img class="partner-logo" alt="logo sony" src="/images/partners/Sony.webp" />
                    </a>

                    <a href="https://www.boschsecurity.com/es/es/soluciones/soluciones-de-conferencias/" target="_blank" rel="noopener noreferrer">
                        <img class="partner-logo" alt="logo bosch" src="/images/partners/Bosch.webp" />
                    </a>

                    <a href="https://www.wowza.com/" target="_blank" rel="noopener noreferrer">
                        <img class="partner-logo" alt="logo wowza" src="/images/partners/Wowza.webp" />
                    </a>
                </section>

                <section className="flex acenter">
                    <a href="https://www.aten.com/eu/en/market-and-solutions/success-stories/eu/spica-avsystemintegration/" target="_blank" rel="noopener noreferrer">
                        <img class="partner-logo" alt="logo aten" src="/images/partners/Aten.webp" />
                    </a>

                    <a href="https://www.christiedigital.com/press-releases/school-of-medicine-opts-for-4k-laser-projection/" target="_blank" rel="noopener noreferrer">
                        <img class="partner-logo" alt="logo christie" src="/images/partners/Christie.webp" />
                    </a>

                    <a href="https://www.poly.com/es/es" target="_blank" rel="noopener noreferrer">
                        <img class="partner-logo" alt="logo poly" src="/images/partners/Poly.webp" />
                    </a>

                    <a href="https://www.barco.com/es/" target="_blank" rel="noopener noreferrer">
                        <img class="partner-logo" alt="logo barco" src="/images/partners/Barco.webp" />
                    </a>
                </section>

                <section className="flex acenter">
                    <a href="https://newline-interactive.com/es/" target="_blank" rel="noopener noreferrer">
                        <img class="partner-logo" alt="logo newline" src="/images/partners/Newline.webp" />
                    </a>

                    <a href="https://www.hp.com/es-es/shop/offer.aspx?p=z-by-hp-workstations&ctrl=f&gclid=Cj0KCQiAraSPBhDuARIsAM3Js4pGuuJNkLz71oeQ27Fh0s4LYF0CC2CIx2pHCZCm-NSSR9EitZHNT2gaAq-OEALw_wcB&gclsrc=aw.ds" target="_blank" rel="noopener noreferrer">
                        <img class="partner-logo" alt="logo hp" src="/images/partners/HP.webp" />
                    </a>

                    <a href="https://www.newtek.com/" target="_blank" rel="noopener noreferrer">
                        <img class="partner-logo" alt="logo newtek" src="/images/partners/Newtek.webp" />
                    </a>

                    <a href="https://www.lgbusiness.es/display-profesional/" target="_blank" rel="noopener noreferrer">
                        <img class="partner-logo" alt="logo lg" src="/images/partners/LG.webp" />
                    </a>
                </section>
            </div>

        </div>
    )
}

export default Partners